import _ from 'lodash';
import { semanticSearchApi } from '../../../../components/apis/core_basic_api/search';
import { setWordingApi, removeWordingApi } from 'library-@/apis/core_basic_api/wording';
import { getCurrentLanguage } from 'library-@/utils/getCurrentLanguage';

const done = resp => _.get(resp, 'data', {});

export default class WordingService {
    constructor(patentId) {
        this.patentId = patentId;
        this.lang = getCurrentLanguage();
    }

    async setWording(data) {
        const result = await setWordingApi(data).then(done);
        const wording_id = _.get(result, 'wording_id');
        return {
            wording_id,
            status: !!wording_id,
        };
    }

    async removeWording(wordingId) {
        const result = await removeWordingApi(wordingId).then(done);
        const wording_id = _.get(result, 'wording_id');
        return {
            wording_id,
            status: !!wording_id,
        };
    }

    async semanticSearch(query) {
        const response = await semanticSearchApi({ query, immediately: true });
        return _.get(response, 'data.data', {});
    }
}
